import { useEffect, useState } from "react";

function useFetch(fetchCallback, deps = [], defaultData) {
  const [state, setState] = useState({
    data: defaultData,
    loading: true,
    error: null,
  });

  if (!fetchCallback || typeof fetchCallback !== "function") {
    throw new Error("fetchCallback is not a function.");
  }

  const refetch = async () => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));
    try {
      const data = await fetchCallback();
      setState({
        data: data,
        loading: false,
        error: null,
      });
    } catch (e) {
      console.error(e);
      setState((prevState) => ({
        ...prevState,
        loading: false,
        error: e,
      }));
    }
  };

  useEffect(() => {
    refetch();
  }, deps);

  return {
    ...state,
    refetch,
  };
}

export default useFetch;
